import { render } from "./ChatListing.vue?vue&type=template&id=5479beac&scoped=true&ts=true"
import script from "./ChatListing.vue?vue&type=script&lang=ts"
export * from "./ChatListing.vue?vue&type=script&lang=ts"

import "./ChatListing.vue?vue&type=style&index=0&id=5479beac&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5479beac"]])

export default __exports__